import { FC, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { RepriseReimbursementResourcesLogo } from "../../assets";
import { AuthContext } from "../../context/authContext";
import { AuthenticatedRoutes, PublicRoutes, ManufacturerRoutes, RepRoutes, RegionalManagerRoutes, } from "../../routes/AppRoutes";

const HubSplashScreen: FC = (): JSX.Element => {
  const { isUserAuthorized, userData, isRestoreCalled, restoreSession } = useContext(AuthContext);
  const navigate = useNavigate();
  const { id } = useParams();


  const checkForAuthentication = () => {
    if (isUserAuthorized) {
      if (!userData) return;

      if (userData.ref_type === "Manufacturer") {
        const indexRoute = ManufacturerRoutes.find((route) => route.isIndex);
        if (indexRoute) navigate(indexRoute.route);
        return;
      }

      if (userData.ref_type === "rep") {
        const indexRoute = RepRoutes.find((route) => route.isIndex);
        if (indexRoute) {
          if (indexRoute.route === "/statistics/:id") {
            if (id === undefined) {
              navigate(`/statistics/${userData.id}`);
            } else {
              navigate(`/statistics/${id}`);
            }
          } else {
            navigate(indexRoute.route);
          }
        }
        return;
      }

      if (userData.ref_type === "regional_manager") {
        const indexRoute = RegionalManagerRoutes.find((route) => route.isIndex);
        if (indexRoute) navigate(indexRoute.route);
        return;
      }

      // Fallback for all other authenticated users
      if (!window.location.host.includes("baa")) {
        const indexRoute = AuthenticatedRoutes.find((route) => route.isIndex);
        if (indexRoute) navigate(indexRoute.route);
      } else {
        navigate("/");
      }
    } else {
      const indexRoute = PublicRoutes.find((route) => route.isIndex);
      if (indexRoute) navigate(indexRoute.route);
    }
  };

  useEffect(() => {
    if (isRestoreCalled) {
      checkForAuthentication();
    } else if (!userData) {
      restoreSession();
    } else {
      const indexRoute = PublicRoutes.find((route) => route.isIndex);
      if (indexRoute) navigate(indexRoute.route);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRestoreCalled, isUserAuthorized]);

  return (
    <div className="container-fluid row justify-content-center align-items-center pt-4 pb-5" style={{ height: '100vh' }}>
      <div className="col-12 text-center">
        <img height="70px" className="img-fluid mt-3" src={RepriseReimbursementResourcesLogo} alt="Site logo" />

        <div className="mt-2">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubSplashScreen;
